import { Form } from "react-bootstrap";
import "./reset-password-modal.scss";
import EyeIcon from "./EyeIcon";
import { useState } from "react";

const PasswordInputContainer = ({
  newPassword,
  setNewPassword,
  currentPassword,
  setCurrentPassword,
  checkCurrentPassword,
  err,
  checkNewPassword,
  passwordCriteria,
}) => {
  const [passwordVisiblity, setPasswordVisiblity] = useState({
    showCurrentPassword: false,
    showNewPassword: false,
  });
  const toggleCurrentPasswordVisibility = () => {
    setPasswordVisiblity((prev) => ({
      ...prev,
      showCurrentPassword: !prev.showCurrentPassword,
    }));
  };

  const toggleNewPasswordVisibility = () => {
    setPasswordVisiblity((prev) => ({
      ...prev,
      showNewPassword: !prev.showNewPassword,
    }));
  };

  return (
    <>
      <Form.Group>
        <Form.Label className="fs-12">Current password</Form.Label>
        <div
          className={`formControlContainer ${
            err.currentPasswordErr.length > 0 && "formControlContainer__err"
          }`}
        >
          <Form.Control
            type={passwordVisiblity.showCurrentPassword ? "text" : "password"}
            className="formControlInput"
            placeholder="Enter current password"
            value={currentPassword}
            onChange={(e) => {
              setCurrentPassword(e.target.value);
              checkCurrentPassword(e.target.value);
            }}
          />
          <EyeIcon
            showPassword={passwordVisiblity.showCurrentPassword}
            onClick={toggleCurrentPasswordVisibility}
          />
        </div>
        {err.currentPasswordErr.length > 0 && (
          <div className="errContainer">{err.currentPasswordErr}</div>
        )}
      </Form.Group>
      <Form.Group>
        <Form.Label className="fs-12">New password</Form.Label>
        <div
          className={`formControlContainer ${
            err.newPasswordErr.length > 0 && "formControlContainer__err"
          }`}
        >
          <Form.Control
            type={passwordVisiblity.showNewPassword ? "text" : "password"}
            className="formControlInput"
            placeholder="Enter New password"
            value={newPassword}
            onChange={(e) => {
              setNewPassword(e.target.value);
              checkNewPassword(e.target.value);
            }}
          />
          <EyeIcon
            showPassword={passwordVisiblity.showNewPassword}
            onClick={toggleNewPasswordVisibility}
          />
        </div>
        {err.newPasswordErr.length > 0 && (
          <div className="errContainer">{err.newPasswordErr}</div>
        )}
        <div className="instructions">
          <ul>
            <li
              className={`${
                newPassword &&
                (passwordCriteria.hasMinLength
                  ? "password__rule--met"
                  : "password__rule--unmet")
              }`}
            >
              Use more than 10 characters
            </li>
            <li
              className={`${
                newPassword.length > 0 &&
                (passwordCriteria.hasMixedCaseAndNumber
                  ? "password__rule--met"
                  : "password__rule--unmet")
              }`}
            >
              Include uppercase, lowercase, and a number
            </li>
            <li
              className={`${
                newPassword &&
                (passwordCriteria.hasSpecialChar
                  ? "password__rule--met"
                  : "password__rule--unmet")
              }`}
            >
              Include a special character
            </li>
          </ul>
        </div>
      </Form.Group>
    </>
  );
};

export default PasswordInputContainer;
